import { render, staticRenderFns } from "./AccountStats.vue?vue&type=template&id=31259519&"
import script from "./AccountStats.vue?vue&type=script&lang=js&"
export * from "./AccountStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports